import React, { useEffect } from 'react';
import { transformUrl } from './helpers';
import './App.css';

function App() {
  useEffect(() => {
    const url = window.location.href;
    const transformedUrl = transformUrl(url);
    window.location.href = transformedUrl;
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <img src="/logo.png" className="App-logo" alt="logo" />
        <p>
          Please open this link on a device with the Backrs app installed.
        </p>
      </header>
    </div>
  );
}

export default App;
